import React, { useState, useEffect } from 'react';  
import { Oval } from 'react-loader-spinner';  
import styled from 'styled-components';  
import ChartMarketComponent from '../components/Chart_Market';  
import { useNavigate } from 'react-router-dom';  
import { fetchMarketPriceData } from './api'; // api.js からインポート  
  
const Container = styled.div`  
  margin-top: 20px;  
  padding: 0 20px 20px 20px;  
`;  
  
const LoaderOverlay = styled.div`  
  display: flex;  
  justify-content: center;  
  align-items: center;  
  position: absolute;  
  top: 0;  
  left: 0;  
  height: 100%;  
  width: 100%;  
  background: #fafafa;  
  z-index: 1500;  
  flex-direction: column;  
`;  
  
const LoadingText = styled.div`  
  margin-top: 10px;  
  font-size: 16px;  
  color: #333;  
`;  
  
const ContainerButton = styled.div`  
  padding: 0 20px 20px 20px;  
`;  
  
const Button = styled.button`  
  width: 100%;  
  padding: 10px;  
  font-size: 16px;  
  background-color: green;  
  color: white;  
  border: none;  
  border-radius: 5px;  
  cursor: pointer;  
  align-self: center;  
`;  
  
const cities = ['札幌市', '仙台市', '東京都', '横浜市', '金沢市', '名古屋市', '京都市', '大阪市', '神戸市', '広島市', '高松市', '北九州市', '福岡市', '沖縄県'];  
const items = ['ピーマン', 'きゅうり', 'トマト', 'ミニトマト', 'いちご'];  
const monthsOptions = [1, 3, 6, 12, 24];  
  
const MarketData = () => {  
  const [data, setData] = useState([]);  
  const [loading, setLoading] = useState(true);  
  const [error, setError] = useState(null);  
  const [selectedCity, setSelectedCity] = useState('東京都');  
  const [selectedItem, setSelectedItem] = useState('ピーマン');  
  const [selectedMonths, setSelectedMonths] = useState(3);  
  const [showPrices, setShowPrices] = useState(true);  
  const navigate = useNavigate();  
  
  const handleBack = () => {  
    try {  
      navigate(-1);  
    } catch (error) {  
      console.error('Error navigating back:', error);  
    }  
  };  
  
  useEffect(() => {  
    const fetchData = async () => {  
      setLoading(true);  
      try {  
        const result = await fetchMarketPriceData(selectedItem, selectedMonths);  
        setData(result);  
      } catch (error) {  
        setError(error.message);  
      } finally {  
        setLoading(false);  
      }  
    };  
    fetchData();  
  }, [selectedItem, selectedMonths]);  
  
  if (loading) {  
    return (  
      <LoaderOverlay>  
        <Oval  
          height={80}  
          width={80}  
          color="#4fa94d"  
          ariaLabel="oval-loading"  
          secondaryColor="#4fa94d"  
          strokeWidth={2}  
          strokeWidthSecondary={2}  
        />  
        <LoadingText>データ取得中...</LoadingText>  
      </LoaderOverlay>  
    );  
  }  
  
  if (error) {  
    return <p>Error: {error}</p>;  
  }  
  
  return (  
    <div>  
      <h2>{selectedCity}産地別{selectedItem}価格チャート</h2>  
      {/* 市場選択用のドロップダウン */}  
      <label htmlFor="city-select">市場:</label>  
      <select  
        id="city-select"  
        value={selectedCity}  
        onChange={(e) => setSelectedCity(e.target.value)}  
      >  
        {cities.map(city => (  
          <option key={city} value={city}>  
            {city}  
          </option>  
        ))}  
      </select>  
      {/* 作物選択用のドロップダウン */}  
      <label htmlFor="item-select">作物:</label>  
      <select  
        id="item-select"  
        value={selectedItem}  
        onChange={(e) => setSelectedItem(e.target.value)}  
      >  
        {items.map(item => (  
          <option key={item} value={item}>  
            {item}  
          </option>  
        ))}  
      </select>  
      {/* 月数選択用のドロップダウン */}  
      <label htmlFor="months-select">月数:</label>  
      <select  
        id="months-select"  
        value={selectedMonths}  
        onChange={(e) => setSelectedMonths(parseInt(e.target.value, 10))}  
      >  
        {monthsOptions.map(month => (  
          <option key={month} value={month}>  
            {month}ヶ月  
          </option>  
        ))}  
      </select>  
      {/* 価格の表示/非表示を切り替えるチェックボックス */}  
      <label htmlFor="show-prices">価格表示</label>  
      <input  
        type="checkbox"  
        id="show-prices"  
        checked={showPrices}  
        onChange={(e) => setShowPrices(e.target.checked)}  
      />  
      <Container>  
        <ChartMarketComponent data={data} selectedCity={selectedCity} showPrices={showPrices} chartType="production" />  
        <h2>{selectedCity}平均{selectedItem}価格チャート</h2>  
        <ChartMarketComponent data={data} selectedCity={selectedCity} showPrices={showPrices} chartType="average" />  
        <h2>全国平均{selectedItem}価格チャート</h2>  
        <ChartMarketComponent data={data} selectedCity={selectedCity} showPrices={showPrices} chartType="national" />  
      </Container>  
      <ContainerButton>  
        <Button onClick={handleBack}>前の画面に戻る</Button>  
      </ContainerButton>  
    </div>  
  );  
};  
  
export default MarketData;  
